export default
    {
        path:'/policyDecision',
        name:'选科决策',
        redirect:'/policyDecision/main',
        component:()=>import('../views/policyDecision/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/policyDecision/main',
                name:'选科决策主页',
                component:()=>import('../views/policyDecision/main.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/universityExploration',
                name:'大学探索表',
                component:()=>import('../views/policyDecision/universityExploration.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/professionalExploration',
                name:'专业探索表',
                component:()=>import('../views/policyDecision/professionalExploration.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/university',
                name:'大学定位工具',
                component:()=>import('../views/policyDecision/university.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/major',
                name:'专业定位工具',
                component:()=>import('../views/policyDecision/major.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/careerAnchor',
                name:'职业定位工具',
                component:()=>import('../views/policyDecision/careerAnchor.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/matchingSchools',
                name:'成绩匹配院校',
                component:()=>import('../views/policyDecision/matchingSchools.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/universityTable',
                name:'目标大学梯度表',
                component:()=>import('../views/policyDecision/universityTable.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/goals',
                name:'我的目标主页',
                component:()=>import('../views/policyDecision/goals.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/goal',
                name:'我的目标',
                component:()=>import('../views/policyDecision/goal.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/policyDecision/zhiyuan',
                name:'志愿填报',
                component:()=>import('../views/policyDecision/zhiyuan.vue'),
                meta:{requireAuth:true,roles:['student']},
            }
        ]
    }